import * as Sentry from '@sentry/react';
import { useMemo } from 'react';

type LogAttributes = Record<string, string | number | boolean | Array<string | number | boolean>>;

const useSentryLogger = () => {
    return useMemo(
        () => ({
            trace: (message: string, attributes?: LogAttributes) => Sentry.logger.trace(message, attributes),
            debug: (message: string, attributes?: LogAttributes) => Sentry.logger.debug(message, attributes),
            info: (message: string, attributes?: LogAttributes) => Sentry.logger.info(message, attributes),
            warn: (message: string, attributes?: LogAttributes) => Sentry.logger.warn(message, attributes),
            error: (message: string, attributes?: LogAttributes) => Sentry.logger.error(message, attributes),
            fatal: (message: string, attributes?: LogAttributes) => Sentry.logger.fatal(message, attributes),
            fmt: Sentry.logger.fmt,
        }),
        []
    );
};

export default useSentryLogger;
